<template>
    <div>

        <template v-if="tempoOrderDetail">
            <Row :gutter="10">{{tempoOrderDetail.tempoOrderCode}}
                 <span :class="tempoOrderDetail.endReading?'green-text':'orange-text'"> ({{tempoOrderDetail.endReading?'Completed':'Active'}})</span>
                <!--(<span :style="{color: getColor(tempoOrderDetail.status)}">{{tempoOrderDetail.status}}</span>)-->
                <Col :md="8" style="float: right">
                    <Row :gutter="10">
                <Col :md="8" style="color: #444444">Booking Date</Col><Col span="1">:</Col>
                <Col :md="12">{{moment(tempoOrderDetail.date).format('DD MMM YYYY')}}</Col>
                    </Row>
                </Col>
                <!--<span style="float: right;"><span style="color: #444444">Booking Date</span> {{moment(tempoOrderDetail.date).format('DD MMM YYYY')}}</span>-->
            </Row>
            <Row :gutter="10" style="font-size: 15px">
                <Col :md="8">
                    <Row :gutter="10">
                        <Col :md="8" style="color: #444444">City</Col><Col span="1">:</Col>
                        <Col :md="12">{{tempoOrderDetail.city?tempoOrderDetail.city:'-'}}</Col>
                        <Col :md="8" style="color: #444444">Vehicle No</Col><Col span="1">:</Col>
                        <Col :md="12">{{tempoOrderDetail.tempo.platNo}}</Col>
                        <Col :md="8" style="color: #444444">Model</Col><Col span="1">:</Col>
                        <Col :md="12">{{tempoOrderDetail.tempo.name?tempoOrderDetail.tempo.name :'-'}}</Col>
                        <Col :md="8" style="color: #444444">Contract Type</Col><Col span="1">:</Col>
                        <Col :md="12">{{tempoOrderDetail.contractor.type?contractType[tempoOrderDetail.contractor.type]:'-'}}</Col>
                    </Row>
                </Col>
                <Col :md="8">
                    <Row :gutter="10">
                        <Col :md="8" style="color: #444444">Driver Name</Col><Col span="1">:</Col>
                        <Col :md="12">{{tempoOrderDetail.driverDetail.name}}</Col>
                        <Col :md="8" style="color: #444444">Driver Mobile</Col><Col span="1">:</Col>
                        <Col :md="12">{{tempoOrderDetail.driverDetail.mobile}}</Col>
                        <Col :md="8" style="color: #444444">Contractor</Col><Col span="1">:</Col>
                        <Col :md="12">{{tempoOrderDetail.contractor.name}}
                            <template>({{tempoOrderDetail.contractor.mobile}})</template></Col>
                    </Row>
                </Col>
                <Col :md="8">
                    <Row :gutter="10">
                        <Col :md="8" style="color: #444444">Start KM</Col><Col span="1">:</Col>
                        <Col :md="12">{{tempoOrderDetail.startReading}}</Col>
                        <Col :md="8" style="color: #444444">End KM</Col><Col span="1">:</Col>
                        <Col :md="12">{{tempoOrderDetail.endReading?tempoOrderDetail.endReading:'-'}}</Col>
                        <Col :md="8" style="color: #444444">KM Run</Col><Col span="1">:</Col>
                        <Col :md="12">{{tempoOrderDetail.endReading?(tempoOrderDetail.endReading - tempoOrderDetail.startReading):'-'}}</Col>
                      <Col :md="8" style="color: #444444">Price</Col><Col span="1">:</Col>
                      <Col :md="12">{{tempoOrderDetail.price?tempoOrderDetail.price:'-'}}</Col>
                    </Row>
                </Col>
            </Row>
            <Divider></Divider>
            <Row :gutter="10">
                <Col :md="6">Total Orders: {{orders.length}}</Col>
                <Col :md="6">Status:
                    <!--<span style="cursor: pointer;text-decoration: underline" @click="openChangeStatusPopup">-->
                    <!--{{tempoOrderDetail.InternalStatus.name}}-->
                <!--</span>-->
                </Col>
                <Col :md="6">Total Wt: {{totalWtOfOrders}}</Col>
                <Button v-if="isAdmin" style="float: right" @click="exportTempoOrderDetailOrders">Export CSV</Button>
            </Row>
        </template>

        <Spin fix size="small" v-if="!this.$route.params.id"></Spin>
        <hot-table :settings="hotSettings" ref="hotTableComponent" style="margin: 20px 0 0 0">
            <hot-column v-for="(colset, index) in columns" :settings="colset" :key="index">
                <component hot-editor hot-renderer v-bind:is="colset.component"></component>
            </hot-column>
        </hot-table>

        <manage-order :orderId="orderId" ref="manage-order-page" :viewPath="viewPath"></manage-order>
    </div>
</template>

<script>
    import { HotTable, HotColumn } from '@handsontable/vue'
    import Handsontable from 'handsontable'
    import {SUBSCRIBE_ORDERS_BY_TEMPO_ORDER_ID, SUBSCRIBE_TEMPO_ORDER_BY_ID} from "../../graphql/subscription/tempoOrders"
    import moment from 'moment'
    import {Constants} from '../../Constants/Constant'
    import {calculateTotalWeightOfOrders} from "../ExcelTruckOrders/Settings"
    import {orderPriorityColors} from "../ExcelFormattedOrders/Settings";
    import ManageOrder from "../Manage Order/ManageOrder";
    import {contractType} from "../ExcelContractors/RendererFunctions";
    import {getAddressString, orderDetailsRenderer} from "../ExcelFormattedOrders/RendererFunctions";

    export default {
        name: "TempoOrderDetail",
        components: {ManageOrder, HotTable, HotColumn },
        provide() {
            return {
                getManageOrderDrawer: () => this.manageOrderDrawer,
                setManageOrderDrawer: (data) => { this.manageOrderDrawer = data },
                getOrder: () => this.order,
                closeAssignVehicleDialog: (data) => { },
            }
        },
        apollo: {
            $subscribe: {
                orders: {
                    query: SUBSCRIBE_ORDERS_BY_TEMPO_ORDER_ID,
                    skip () {return !this.$route.params.id},
                    variables() {
                        return {
                            tempoOrderId: this.$route.params.id
                        }
                    },
                    result ({ data }) {
                        this.orders = data.orders
                        this.prepareSheetData(data.orders)
                        this.prepareArrayThenEvaluateWt(data.orders)
                    },
                },
                tempoOrderDetail: {
                  query: SUBSCRIBE_TEMPO_ORDER_BY_ID,
                  skip () {return !this.$route.params.id},
                  variables() {
                    return {
                      tempoOrderId: this.$route.params.id
                    }
                  },
                  result ({ data }) {
                      this.tempoOrderDetail = data.tempoOrderDetail[0]
                  }
                },
            },
        },
        data: function () {
            return{
                Constants: Constants,
                moment: moment,
                tempoOrderDetail: null,
                orders: [],
                totalWtOfOrders: 0,
                changeStatusPopup: false,
                loader1: false,
                errMessages: [],
                manageOrderDrawer: false,
                orderId: 'aa00aa00-000a-0000-aaaa-aaaaaa00000a',
                currentOrderStatus: '',
                order: '',
                viewPath: '',
                columns: [
                    //table_key_intermediate
                    {
                        title: 'Created On',
                        data: 'createdAt',
                        type: 'date',
                        dateFormat: 'DD MMM \'YY hh:mm A'
                    },
                    {
                        title: 'Updated On',
                        data: 'updatedAt',
                        type: 'date',
                        dateFormat: 'DD MMM \'YY hh:mm A'
                    },
                    {
                        title: 'Pickup<br> Date',
                        data: 'orders_pickupDate',
                        type: 'date', dateFormat: 'DD/MM/YYYY'
                    },
                    {
                        title: 'ERP Order No',
                        data: 'orderNumber',
                        renderer: this.orderNumberRenderer
                    },
                    {
                        title:'Status',
                        data: 'internalStatus'
                    },
                    {
                        title:'Comment',
                        data: 'comment'
                    },
                    {
                        title:'LR No.',
                        data: 'orderDetails_lrName_lrObject'
                    },
                    {
                        title:'Client Name',
                        data: 'clientName'
                    },
                    {
                        title:'Pickup Point',
                        data: 'pickupPartyName'
                    },
                    {
                        title:'Drop Point',
                        data: 'dropPartyName'
                    },
                    {
                        title:'Company',
                        data: 'companyName'
                    },
                    {
                        title:'Total<br> Weight',
                        data: 'kg',
                        type: 'numeric'
                    },
                    {
                        title:'Order<br> Details',
                        data: 'boxes',
                        renderer: (...args) => orderDetailsRenderer(...args, this, 'orders')
                    },
                    {
                        title:'Eway Bill No',
                        data: 'orderDetails_ewayBillNo'
                    }
                ],
                hotSettings: {
                    data: null,
                    readOnly: true,                             //default all cells readOnly
                    fillHandle: false,
                    copyPaste: false,
                    licenseKey: "non-commercial-and-evaluation",
                    // rowHeaders: true,
                    autoRowSize: false,
                    autoColumnSize: false,
                    colWidths: [120, 120, 110, 145, 145, 180, 100, 145, 145, 145, 145, 100, 100, 130],
                    className: "htCenter htMiddle",
                    filters: true,
                    dropdownMenu: ['filter_by_condition', 'filter_operators', 'filter_by_condition2', 'filter_by_value', 'filter_action_bar'],
                    columnSorting: { sortEmptyCells: true },
                },
                confirmDialog: false,
                confirmObj: {},
                updateRecord_loader: false,
                contractType: contractType
            }
        },
        computed: {
          isAdmin: function(){
            return this.$store.state.userObj.role[0].id === Constants.adminRoleId
          }
        },
        methods:{
            orderNumberRenderer(instance, td, row, col, prop, value, cellProperties) {
                Handsontable.renderers.TextRenderer.apply(this, arguments);
                let priority = instance.getDataAtRowProp(row, 'priority')                               //prop name 'priority'

                td.innerHTML = value.substring(0, 9) + '<p>' + value.substring(9, value.length) + '</p>'

                if(orderPriorityColors[priority]){
                    td.style.color = orderPriorityColors[priority]
                }
                td.classList.add('order-num-txt')
                let pRow = instance.toPhysicalRow(row)                               //When accessing original array
                let order = this.orders[pRow]
                let self = this
                td.onclick = function() {
                    self.editOrder(order)
                }
            },
            editOrder(order){
                this.orderId = order.id;
                this.viewPath = order.internalStatus.viewPath;      //Load form based on internalStatus.viewPath
                this.order = order;
                this.currentOrderStatus = order.internalStatus.id;
                this.manageOrderDrawer = true;
            },
            prepareSheetData(data){
                let mainArr = []
                data.forEach(curnt => {
                    curnt.obj = {
                        createdAt: moment(curnt.createdAt).format('DD MMM \'YY hh:mm A'),
                        updatedAt: moment(curnt.updated_at).format('DD MMM \'YY hh:mm A'),
                        orders_pickupDate: moment(curnt.pickupDate, 'YYYY-MM-DD').format('DD/MM/YYYY'),
                        orderNumber: curnt.orderNumber,
                        internalStatus: curnt.internalStatus.name,
                        comment: curnt.notes.length?curnt.notes[0].note:'',
                        clientName: curnt.clientobject.name,
                        pickupPartyName: curnt.orderDetails&&curnt.orderDetails.pickupPoint&&curnt.orderDetails.pickupPoint.pickupPartyId?
                            curnt.orderDetails.pickupPoint.pickupPartyName:curnt.pickuppartyobject.name,
                        dropPartyName: curnt.orderDetails&&curnt.orderDetails.dropPoint&&curnt.orderDetails.dropPoint.dropPartyId?
                            curnt.orderDetails.dropPoint.dropPartyName:curnt.droppingpartyobject.name,
                        companyName: curnt.pickuppartyobject.name,
                        kg: curnt.materials.kg,
                        boxes: curnt.materials.boxes,
                        orders_note: curnt.note?curnt.note:'-',
                        orderDetails_lrName_lrObject: curnt.orderDetails&&curnt.orderDetails.lrObject?curnt.orderDetails.lrObject.lrName:'',
                        orderDetails_ewayBillNo: curnt.orderDetails&&curnt.orderDetails.ewayBillNo?curnt.orderDetails.ewayBillNo:'-',
                        priority: curnt.priority,
                        internalStatusId: curnt.internalstatus,
                        unlink: 'unlink'
                    }
                    mainArr.push(curnt.obj)
                })
                this.hotSettings.data = mainArr
            },
            prepareArrayThenEvaluateWt(arr){
                arr = arr.map((obj) => {return {order: obj}})
                this.totalWtOfOrders = calculateTotalWeightOfOrders(arr)
            },
            exportTempoOrderDetailOrders(){
              let exportPlugin = this.$refs.hotTableComponent.hotInstance.getPlugin('exportFile');
              let str = exportPlugin.exportAsString('csv', {columnHeaders: true});

              let json = {
                'TempoOrder No': this.tempoOrderDetail.tempoOrderCode,
                'Status': this.tempoOrderDetail.endReading?'Completed':'Active',
                'Booking Date': moment(this.tempoOrderDetail.date).format('DD MMM YYYY'),
                'City': this.tempoOrderDetail.city?this.tempoOrderDetail.city:'-',
                'Vehicle No': this.tempoOrderDetail.tempo.platNo,
                'Model': this.tempoOrderDetail.tempo.name?this.tempoOrderDetail.tempo.name:'-',
                'Contract Type': this.tempoOrderDetail.contractor.type,
                'Driver Name': this.tempoOrderDetail.driverDetail.name,
                'Driver Mobile': this.tempoOrderDetail.driverDetail.mobile,
                'Contrctor': this.tempoOrderDetail.contractor.name + '/' + this.tempoOrderDetail.contractor.mobile,
                'Start KM': this.tempoOrderDetail.startReading,
                'End KM': this.tempoOrderDetail.endReading,
                'KM Run': this.tempoOrderDetail.endReading? (this.tempoOrderDetail.endReading - this.tempoOrderDetail.startReading):'-'
              }
              str = str.replace(/<\/?[^>]+(>|$)/g,"") + '\n\n';        //Remove html tags if any
              Object.keys(json).forEach((key) => {
                str = str + key + ',' + json[key] + '\n';
              });

              let blob = new Blob([str], {type: 'text/plain'});
              const a = window.document.createElement('a');
              a.href = window.URL.createObjectURL(blob);
              a.download = 'tempoOrderDetail_Orders_' + moment().format('DD_MMM_YYYY_HH_mm') +'.csv';
              document.body.appendChild(a);
              a.click();
              document.body.removeChild(a);
            }
        },
        mounted(){}
    }
</script>

<style scoped>
    /deep/  .ivu-spin-fix {
        top: 43px;
        left: 16px;
        z-index: 8;
        width: 86vw;
        height: 40vh;
    }
    /deep/ .handsontable > .ht_master{
        font-size: 14px;
    }
    /deep/ .handsontable > .ht_master > .wtHolder{
        /*width: 100% !important;*/
        width: unset !important;
        height: unset !important;
    }
    /deep/ .handsontable span.colHeader {
        font-size: 13px;
    }
    /deep/.handsontable td{
        vertical-align: middle !important;
        padding: 0 1px 0 1px !important;
        white-space: unset !important;
        font-size: 13px;
    }

    /deep/.handsontable th{
        background-color: #d9d9d9;
        color: #222;
        text-align: center;
        font-weight: 600;
        vertical-align: middle !important;
        white-space: nowrap !important;
        padding: 0 0px 0 0px !important;
    }
    .filterInput{
        width: 80%;
    }
    .plus-value{
        color: green;
    }
    .minus-value{
        color: red;
    }
    .green-text{
      color:green;
    }
    .orange-text{
      color:orange;
    }
</style>
<style>
    .order-num-txt:hover {
        text-decoration: underline;
    }
</style>
<style src="../../../node_modules/handsontable/dist/handsontable.full.css"></style>
